import React from "react";
import { Navigate } from "react-router-dom";

import { APP_PATH, LocalStorageKeys, ROUTES } from "@is/constants";
import { usePageParams } from "@is/hooks";
import { LocalStorageService } from "@is/services";

type Props = {
  children: React.ReactElement;
  navigate?: boolean;
};

function Registered({ children, navigate }: Props) {
  const deviceId = LocalStorageService.getItem(LocalStorageKeys.DeviceId);
  const { tenantId } = usePageParams();

  if (!deviceId) {
    const startUrl = LocalStorageService.getItem(LocalStorageKeys.StartUrl);
    if (startUrl) {
      window.location.href = startUrl;
    } else {
      const query = tenantId ? `?t=${tenantId}` : "";

      window.location.href = `${APP_PATH}${ROUTES.WelcomeView}${query}`;
    }
    return null;
  }

  if (navigate) {
    return <Navigate to={ROUTES.EntryView} replace={true} />;
  }

  return children;
}

export default Registered;
